<span
	[ngClass]="{
		'success-dot': row.estadoNombre == 'RECIBIDO CONFORME' || row.estadoNombre == 'ACUSE POR SII' || row.estadoNombre == 'NO RECLAMADO EN PLAZO',
		'warning-dot': row.estadoNombre == 'RECIBIDO EN SII' || row.estadoNombre == 'RECIBIDO EN CORREO',
		'error-dot': row.estadoNombre == null || row.estadoNombre == undefined
	}"
	[ngbTooltip]="getTooltipFirstStatus(row.estadoNombre)"></span>

<span [ngClass]="getSecondDotClass(row)" [ngbTooltip]="getTooltipSecondStatus(row)"></span>

<span [ngClass]="getThirdDotClass(row)" [ngbTooltip]="getTooltipThirdStatus(row)"></span>
